import { createComponent } from 'react-fela'

const line = props => ({
  height: props.stroke || 3,
  backgroundColor: props.color,
  transition: '500ms all ease-out',
  width: props.width || 0
})

export default createComponent(line, 'div', [
  'data-parallax-line'
])



// WEBPACK FOOTER //
// ../styleguide/Line.js